import { jsx as _jsx } from "react/jsx-runtime";
import Divider from "@mui/material/Divider";
import { styled, useThemeProps } from "@mui/material/styles";
import { clsx } from "clsx";
import { menuDividerClasses, } from "./MenuDivider.classes";
import { getUtilityComponentName } from "./styles";
const componentName = getUtilityComponentName("MenuDivider");
const MenuDividerRoot = styled(Divider, {
    name: componentName,
    slot: "root",
    overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
    height: 18,
    margin: theme.spacing(0, 0.5),
}));
export default function MenuDivider(inProps) {
    const props = useThemeProps({ props: inProps, name: componentName });
    const { className, classes = {}, sx, ...dividerProps } = props;
    return (_jsx(MenuDividerRoot, { orientation: "vertical", ...dividerProps, className: clsx([menuDividerClasses.root, className, classes.root]), sx: sx }));
}
